import { SideBar } from "layouts/SideBar/SideBar";

export default SideBar;
